import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { GetItemsParams } from '../../attorney/service/attorney.model';
import { Observable } from 'rxjs';

export interface Appointment {
  appointmentId: number;
  patientId: number;
  firstName: string;
  lastName: string;
  appointmentType: string;
}

export interface AppointmentResults {
  date: string;
  totalAppointment: number;
  appointments: Appointment[];
}

export interface PatientStatistics {
  activePatients: {
    total: number;
    dischargeToday: number;
  };
  internalMedicine: SpecialistStats;
  orthopedist: SpecialistStats;
  neurologist: SpecialistStats;
}

export interface SpecialistStats {
  total: number;
  complete: number;
  pending: number;
}

@Injectable({
  providedIn: 'root'
})
export class HomepageService {
  constructor(private apiService: HttpService) {}

  GetAppointmentsList(param: GetItemsParams): Observable<AppointmentResults[]> {
    let params = this.apiService.Params;
    params = params.set('clinicId', param.clinicId || 0);
    params = params.set('fromDate', param.fromDate || Date());
    params = params.set('toDate', param.toDate || Date());
    return this.apiService.getData(`Dashboard/Appointments`, params);
  }
  GetAppointmentsStatus(param: GetItemsParams): Observable<PatientStatistics> {
    let params = this.apiService.Params;
    params = params.set('clinicId', param.clinicId || 0);
    return this.apiService.getData(`Dashboard/GetAppointmentStats`, params);
  }
}
